import type { Nullable } from '~/types'
import type { SupportedLocales } from '#shared/types/locales'

export type LocalizedText = Partial<Record<'En' | 'Fr', string>>

/**
 * Get the localized text from a model.
 *
 * @param model The model to get the localized text from.
 * @param locale The locale to get the localized text for.
 * @returns The localized text.
 */
export function getLocalizedText(
  model?: Nullable<LocalizedText>,
  locale: SupportedLocales = 'en',
): string {
  if (!model) {
    return ''
  }

  return locale === 'fr'
    ? (model.Fr ?? model.En ?? '')
    : (model.En ?? model.Fr ?? '')
}
